module.exports = __webpack_public_path__ + "img/under65.90fe25c2.png";